// extracted by mini-css-extract-plugin
export default {"field":"LabelValueField_field__1h5B8","label":"LabelValueField_label__3l2Hf","value":"LabelValueField_value__1FGDF","link":"LabelValueField_link__2KKB7"};